export const GRID_VIEW = 'GRID_VIEW';
export const LIST_VIEW = 'LIST_VIEW';
export const COMMENT_MSG = 'The Discussion is locked. Cannot add new comment.'
export const FOODBUY_ITEM = 'FoodBuy Item Level Spend';
export const FOODBUY_ALLOWANCE = 'FoodBuy Allowances Solutions';
export const FOODBUY_SOL = `Buy Right - "Janets Programs SOL"`
export const RebateProductLists = 'Rebate Product Lists';
export const CompactRebates = 'Compact Rebate Product List';
export const EndpointSecretKey = `${process.env?.BR_ENDPOINT_SECRET?.toString() || 'buyrightpurchasing123'}`;